import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { LoginViewModel } from "../../features/login/login-viewmodel";
import { AppRoutes } from "../../routes/routes";
import { useViewModel } from "../../viewmodel/use-view-model";
export const LoginView = () => {
    const vm = useViewModel(LoginViewModel);
    const navigate = useNavigate();
    useEffect(() => {
        // for logged user, we navigate to /user route
        if (vm.isOAuthEnabled && vm.isOAuthAuthenticated) {
            navigate(AppRoutes.User);
            return;
        }
        if (vm.isTokenEnabled && vm.isTokenAvailable) {
            navigate(AppRoutes.User);
            return;
        }
    }, []);
    return (_jsx(_Fragment, { children: _jsx("div", { className: "d-flex justify-content-center align-items-center", children: _jsxs("div", { className: "card mt-5 mt-5 w-50", children: [_jsx("h6", { className: "card-header pt-2 pb-2", children: "Log in" }), _jsxs("div", { className: "card-body", children: [vm.isOAuthEnabled && !vm.isOAuthAuthenticated &&
                                _jsxs(_Fragment, { children: [_jsx("p", { children: "To continue, please log in" }), _jsx("button", { type: "button", className: "btn btn-primary", onClick: () => navigate(AppRoutes.OAuthLogin), children: "Log in" })] }), vm.isTokenEnabled && !vm.isTokenAvailable &&
                                _jsxs(_Fragment, { children: [_jsx("p", { children: "To continue, please configure authorisation token in Setup" }), _jsx("button", { type: "button", className: "btn btn-primary", onClick: () => navigate(AppRoutes.Setup), children: "Configure token" })] })] })] }) }) }));
};
